export default __webpack_public_path__ + "static/ipsen-c6b28364f22015ad6d61ac11d3c266d1.png";